/**
 * Project money summary — the server-side budget-vs-actual totals
 * (`apps/api/src/routes/projects/projects.ts`, org roles step 2):
 *
 *   GET /api/v1/projects/orgs/:orgId/projects/:projectId/money-summary → { summary }
 *   GET /api/v1/projects/orgs/:orgId/projects/money-summary            → { items }
 *
 * Open to every member role, project_manager included — the one place a role
 * without the `accounting` scope sees project money, as four totals and no
 * rows. Figures:
 *   - `budget`           `projects.budget` (NULL = no budget set);
 *   - `spent`            `get_project_spend_summary(org)` — Σ Expenses-category
 *                        debits per journal, the journal attributed to its own
 *                        `project_id`, else to the project of its linked
 *                        expense / AP bill / AR invoice (one project per
 *                        journal; 20261002074749). 0 when it has none;
 *   - `revenue_expected` Σ `revenue_sources.amount_expected` of the project;
 *   - `revenue_received` Σ `revenue_sources.amount_received` of the project;
 *   - `funding_secured`  Σ of the project's awarded + closed funds — their
 *                        installments, else `requested_amount` for a fund
 *                        without installments (20261006210000);
 *   - `funding_pipeline` Σ `fund_index.pipeline_amount` of its pipeline funds.
 *   The two fund figures are 0 for a caller without the `accounting` scope
 *   (`get_project_revenue_summary` reads funds only for that scope).
 * Raw sums, no FX conversion (the same as the screens they replace).
 */
import { z } from "zod";
export const projectMoneySummarySchema = z.object({
    project_id: z.string().uuid(),
    budget: z.number().nullable(),
    spent: z.number(),
    revenue_expected: z.number(),
    revenue_received: z.number(),
    funding_secured: z.number(),
    funding_pipeline: z.number(),
});
/** GET …/projects/:projectId/money-summary. */
export const projectMoneySummaryResponseSchema = z.object({ summary: projectMoneySummarySchema });
/** GET …/projects/money-summary — one entry per project of the org. */
export const projectMoneySummaryListResponseSchema = z.object({ items: z.array(projectMoneySummarySchema) });
//# sourceMappingURL=projectMoney.js.map